var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91659 9.33732H9.58325V10.504H4.91659V9.33732ZM4.91659 7.00399H9.58325V8.17065H4.91659V7.00399ZM8.41659 1.17065H3.74992C3.10825 1.17065 2.58325 1.69565 2.58325 2.33732V11.6707C2.58325 12.3123 3.10242 12.8373 3.74409 12.8373H10.7499C11.3916 12.8373 11.9166 12.3123 11.9166 11.6707V4.67065L8.41659 1.17065ZM10.7499 11.6707H3.74992V2.33732H7.83325V5.25399H10.7499V11.6707Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepDescription);
export default __webpack_public_path__ + "static/media/StepDescription.45a213dbc48ab0577a1870f7e64bbafa.svg";
export { ForwardRef as ReactComponent };